import React, { useState, useRef } from 'react';
import NavBar from '../../components/Navbar/NavBar';
import FooterOne from '../../components/Footer/Footer';
import { Box } from '@mui/material';
import { recentNewsData, successStoriesData, featuredNewsData, tembeaGraduationData, communityDevelopmentData, beadsAlumniData, otherNewsData, newsletterArchivesData } from '../../utils/BeadsData';
import { useNavigate } from 'react-router-dom';
import { NewsIntro, BeadsConceptSection, RecentNews, MoreNewsButton, NewsTab, NewsletterArchives } from '../../components/NewsComponents';


const News = () => {
    const [activeTab, setActiveTab] = useState(0);
    const tabsRef = useRef(null);
    const navigate = useNavigate();

    const handleTabChange = (event, newValue) => {
        setActiveTab(newValue);
    };

    // Reference to the tabs section
    const handleMoreNewsClick = () => {
        tabsRef.current?.scrollIntoView({ behavior: 'smooth' });
    };

    const handleReadMore = () => {
        navigate('/news/beads-concept-note');
    };

    // Define the content for each tab in an array or object
    const tabContent = [
        { label: "Success Stories", content: successStoriesData },
        { label: "Featured News", content: featuredNewsData },
        { label: "Beads Graduation", content: tembeaGraduationData },
        { label: "Community Development", content: communityDevelopmentData },
        { label: "BEADS' Alumni Network", content: beadsAlumniData },
        { label: "Other News", content: otherNewsData },
    ];

    return (
        <Box sx={{ flexGrow: 1 }}>
            <NavBar />

            <NewsIntro />
            <BeadsConceptSection handleReadMore={handleReadMore} />
            <RecentNews recentNewsData={recentNewsData} />
            <MoreNewsButton onClick={handleMoreNewsClick} />
            <Box ref={tabsRef}>
                <NewsTab activeTab={activeTab} handleTabChange={handleTabChange} tabContent={tabContent} />
            </Box>
            <NewsletterArchives newsletterArchivesData={newsletterArchivesData} />

            <FooterOne />
        </Box>
    );
};

export default News;